import {OrderingTypeFilters} from "./restaurant.helper";
import {OrderingTypes, PaymentTypes} from "../constants/common.constants";

function getSanitizedTableNumber(tableNumber) {
	return /^\d+$/.test(tableNumber) ? tableNumber : null;
}

function getSanitizedRestaurantId(restaurantId) {
	return /^\d+$/.test(restaurantId) ? parseInt(restaurantId) : null;
}

function getSanitizedComment(comment) {
	return comment ? decodeURIComponent(comment) : null;
}

function getSanitizedSkipProfile(skipProfile) {
	return skipProfile === "true" ? true : undefined;
}

function getSanitizedApp(app) {
	return app ? app.toLowerCase() : null;
}

function getSanitizedReturnFromAdyen(returnFromAdyen) {
	return returnFromAdyen === "1" ? true : undefined;
}

function getSanitizedOrderId(orderId) {
	return /^\d+$/.test(orderId) ? parseInt(orderId) : null;
}

function getSanitizedOrderType(orderType) {
	return Object.keys(OrderingTypes).includes(orderType) ? orderType : null;
}

function getSanitizedRedirectResult(redirectResult) {
	return redirectResult;
}

function getSanitizedPaymentType(paymentType) {
	const sanitizedPaymentType = /^\d+$/.test(paymentType) ? parseInt(paymentType) : null;
	return Object.values(PaymentTypes).indexOf(sanitizedPaymentType) >= 0 ? sanitizedPaymentType : null;
}

function getSanitizedAdyenSecret(secret) {
	return secret;
}

function getSanitizedUrlParams(urlParams) {
	return {
		...urlParams,
		table: getSanitizedTableNumber(urlParams.table),
		restaurant: getSanitizedRestaurantId(urlParams.restaurant),
		comment: getSanitizedComment(urlParams.comment),
		skipProfile: getSanitizedSkipProfile(urlParams.skipProfile),
		app: getSanitizedApp(urlParams.app),
		returnFromAdyen: getSanitizedReturnFromAdyen(urlParams.returnFromAdyen),
		orderId: getSanitizedOrderId(urlParams.orderId),
		restaurantId: getSanitizedRestaurantId(urlParams.restaurantId),
		orderType: getSanitizedOrderType(urlParams.orderType),
		redirectResult: getSanitizedRedirectResult(urlParams.redirectResult),
		paymentType: getSanitizedPaymentType(urlParams.paymentType),
		secret: getSanitizedAdyenSecret(urlParams.secret),
	};
}

function getUrlParamsFromPath(path) {
	const appIdSearchResult = /\/app\/([a-zA-Z0-9]+)/.exec(path);
	const restaurantSearchResult = /\/restaurant\/([a-zA-Z0-9]+)/.exec(path);
	
	const result = {};
	
	const appId = appIdSearchResult?.length > 1 ? appIdSearchResult[1] : undefined;
	const restaurant = restaurantSearchResult?.length > 1 ? restaurantSearchResult[1] : undefined;
	
	if (appId) {
		result['app'] = appId;
	}
	
	if (restaurant) {
		result['restaurant'] = restaurant;
		result['id'] = restaurant;
	}
	return result;
}

function getUrlParams(actualUrl) {
	//HACK for external login without question mark
	//TODO use window.location.search in future
	actualUrl = actualUrl.replace('/set-restaurant', '/?set-restaurant');
	
	let urlParser = document.createElement('a');
	urlParser.href = actualUrl;
	
	const urlSearch = '' + urlParser.search;
	
	//normal flow
	var encodedColon = urlSearch.includes('%3A') ? '%3A' : '%3a';
	var colonSign = urlSearch.includes(':') ? ':' : encodedColon;
	
	var params = urlSearch
	.replace('?', '')
	.split(colonSign)
	.pop()
	.split('&');
	var dataToStart = {};
	
	var urlParamRegex = /^([A-Za-z0-9_]+)=(.+)$/;
	for (var item in params) {
		var objs = urlParamRegex.exec(params[item]);
		
		if (objs && objs.length >= 3) {
			dataToStart[objs[1]] = objs[2];
		}
	}
	
	dataToStart = {
		...dataToStart,
		...getUrlParamsFromPath(urlParser.pathname)
	}
	
	if (dataToStart.restaurant && !dataToStart.id) {
		dataToStart.id = dataToStart.restaurant;
	}
	
	if (dataToStart.id) {
		try {
			dataToStart.id = Number(dataToStart.id);
		} catch (e) {
			console.log('Wrong restaurant id param in url');
		}
	}
	
	return dataToStart;
}

export const rewriteOldParamsToPath = () => {
	const initialParams = getUrlParams('' + window.location.href);
	if (window.location.search.includes('?app=') || window.location.search.includes('&app=')) {
		window.history.pushState({}, document.title, `/app/${initialParams.app}`)
	} else if (window.location.search.includes('?restaurant=') || window.location.search.includes('&restaurant=')) {
		window.history.pushState({}, document.title, `/restaurant/${initialParams.restaurant}`);
	}
}

const _urlParams = getSanitizedUrlParams(getUrlParams('' + global.location.href));

export const getStartupParams = () => _urlParams;

window.__startupParamsHelper = {
	getStartupParams,
	rewriteOldParamsToPath
};
